export default __webpack_public_path__ + "static/media/tick.17e0e63f.svg";